import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';
import { Toast } from '../../../store/toastSlice';

interface ToastItemProps {
  toast: Toast;
  onClose: (id: string) => void;
  autoHideDuration?: number;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
}

export const ToastItem: React.FC<ToastItemProps> = ({
  toast,
  onClose,
  autoHideDuration = 5000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
}) => {
  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    onClose(toast.id);
  };

  return (
    <Snackbar
      open={true}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={anchorOrigin}
      key={toast.id}
    >
      <Alert
        onClose={handleClose}
        severity={toast.severity as AlertColor}
        variant="filled"
        sx={{
          width: '100%',
          minWidth: '300px',
          boxShadow: 4,
          '& .MuiAlert-message': {
            fontWeight: 500,
          },
        }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
};

